import { render, staticRenderFns } from "./SaEditor.vue?vue&type=template&id=56f6b768&"
import script from "./SaEditor.vue?vue&type=script&lang=js&"
export * from "./SaEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports